import GetEmployeesWithAccessToProjectItemModel from './GetEmployeesWithAccessToProjectItemModel';

export class MonitoringHeaderFilterModel {
  Search!: string;
  SearchPerformers?: string;
  SelectedPerformer!: GetEmployeesWithAccessToProjectItemModel;
  AllMyProjectsChecked: boolean;
  Performers!: GetEmployeesWithAccessToProjectItemModel[];
  TotalWorkTime!: number;
  DateStart!: Date;
  DateEnd!: Date;

  constructor(obj?: Partial<MonitoringHeaderFilterModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
